import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios';

export const getUserInfo = createAsyncThunk('/jarvis/home', async () => {
	const response = await axios.post('/jarvis/home', {})
	return response.data.payload;
})


export const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState: {
        pageTitle: "",  // current page title state management
        resumeCount : 0,
        mockInterviewCount : 0,
        user : {},
        currentMockInterviewes : [],
    },
    reducers: {
        setUserInfo: (state, action) => {
            state.resumeCount = action.payload.resumeCount
            state.mockInterviewCount = action.payload.mockInterviewCount
            state.currentMockInterviewes = action.payload.currentMockInterviewes
        },

        reduceUserCredits: (state, action) => {
            state.user = {...state.user, textMockInterviewCredits : state.user.textMockInterviewCredits-1}
        },

        updateResumeCount: (state, action) => {
            state.resumeCount = action.payload
        },

        addNewMockInterview: (state, action) => {
            state.currentMockInterviewes = [action.payload, ...state.currentMockInterviewes]
        }
    },

    extraReducers: {

		[getUserInfo.pending]: state => {
			state.isLoading = true
		},

		[getUserInfo.fulfilled]: (state, action) => {
			const {resumeCount, mockInterviewCount, currentMockInterviewes, user} = action.payload
            console.log(action.payload)
            state.resumeCount = resumeCount
            state.mockInterviewCount = mockInterviewCount
            state.currentMockInterviewes = currentMockInterviewes
            state.user = user
			state.isLoading = false
		},

		[getUserInfo.rejected]: state => {
			state.isLoading = false
		},
    }
})

export const { setUserInfo, updateResumeCount, addNewMockInterview, reduceUserCredits } = userInfoSlice.actions

export default userInfoSlice.reducer